import { useEffect, useRef, useState } from "react";
import { useInView, useReducedMotion } from "framer-motion";

// Animated number counter. Animates leading digits and preserves any suffix (e.g. "900+", "18Mn").
// Non-numeric placeholders (e.g. "[-]") render as-is.
export const Counter = ({ value, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const reduce = useReducedMotion();
  const [display, setDisplay] = useState(value);

  const match = typeof value === "string" && value.match(/^(\d+)(.*)$/);
  const numeric = !!match;

  useEffect(() => {
    if (!numeric || !inView || reduce) {
      if (numeric && reduce) setDisplay(value);
      return;
    }
    const [, digits, suffix] = match;
    const target = parseInt(digits, 10);
    const pad = suffix ? 0 : digits.length;
    const duration = 1200;
    const t0 = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min((now - t0) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      const current = Math.round(eased * target);
      setDisplay((pad ? String(current).padStart(pad, "0") : String(current)) + suffix);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, numeric, reduce, value]); // eslint-disable-line

  return (
    <span ref={ref} className={className}>
      {numeric ? display : value}
    </span>
  );
};
